export class CancelResponse {
    SuccessOrError: boolean | undefined;
    message: string | undefined;
    data!:any[] | undefined;
}